// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
// eslint-disable-next-line spire/fenced-imports
import { RecursivePartial } from "@insite/shell/Components/Shell/StyleGuide/Types";

import breadcrumbs from "@bg/XDL/PreStyle/breadcrumbs";
import breakpoints from "@bg/XDL/PreStyle/breakpoints";
import clickable from "@bg/XDL/PreStyle/clickable";
import fieldSet from "@bg/XDL/PreStyle/fieldSet";
import fileUpload from "@bg/XDL/PreStyle/fileUpload";
import focus from "@bg/XDL/PreStyle/focus";
import formField from "@bg/XDL/PreStyle/formField";
import helpers from "@bg/XDL/PreStyle/helpers";
import icon from "@bg/XDL/PreStyle/icon";
import lazyImage from "@bg/XDL/PreStyle/lazyImage";
import link from "@bg/XDL/PreStyle/link";
import menu from "@bg/XDL/PreStyle/menu";
import overflowMenu from "@bg/XDL/PreStyle/overflowMenu";
import panelMenu from "@bg/XDL/PreStyle/panelMenu";
import shadows from "@bg/XDL/PreStyle/shadows";
import textArea from "@bg/XDL/PreStyle/textArea";
import textField from "@bg/XDL/PreStyle/textField";
import tokenExFrame from "@bg/XDL/PreStyle/tokenExFrame";
import tooltip from "@bg/XDL/PreStyle/tooltip";
import transition from "@bg/XDL/PreStyle/transition";
import translate from "@bg/XDL/PreStyle/translate";
import zIndex from "@bg/XDL/PreStyle/zIndex";
import modal from "@bgs/XDL/PreStyle/modal";
import tag from "@bgs/XDL/PreStyle/tag";
import toast from "@bgs/XDL/PreStyle/toast";
// custom
import globalStyle from "@bg/XDL/PreStyle/globalStyle";
import accordion from "@bgs/XDL/PreStyle/accordion";
import button from "@bgs/XDL/PreStyle/button";
import checkbox from "@bgs/XDL/PreStyle/checkbox";
import colors from "@bgs/XDL/PreStyle/colors";
import dataTable from "@bgs/XDL/PreStyle/dataTable";
import datePicker from "@bgs/XDL/PreStyle/datePicker";
import drawer from "@bgs/XDL/PreStyle/drawer";
import dynamicDropdown from "@bgs/XDL/PreStyle/dynamicDropdown";
import lists from "@bgs/XDL/PreStyle/lists";
import loadingSpinner from "@bgs/XDL/PreStyle/loadingSpinner";
import pagination from "@bgs/XDL/PreStyle/pagination";
import radio from "@bgs/XDL/PreStyle/radio";
import select from "@bgs/XDL/PreStyle/select";
import tab from "@bgs/XDL/PreStyle/tab";
import typography from "@bgs/XDL/PreStyle/typography";

export default {
    breakpoints,
    colors,
    // focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    // breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    formField,
    // fieldSet,
    // icon,
    // link,
    lists,
    // lazyImage,
    loadingSpinner,
    // menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    // tooltip,
    // translate,
    helpers,
} as RecursivePartial<xBaseTheme>;
